<template>
  <div class="profile-tab-content">
    <section class="cart-section">
      <div class="row">
        <div class="col-12">
          <div class="correction-info-box">
            <h4 class="info-title">
              <i class="fa fa-edit"></i> Profile Correction Request
            </h4>

            <div class="info-content">
              <p class="intro-text">
                The following corrections are available:
              </p>

              <ul class="correction-list">
                <li><i class="fa fa-check-circle"></i> Mobile Number Change</li>
                <li><i class="fa fa-check-circle"></i> Photo Change</li>
                <li><i class="fa fa-check-circle"></i> Signature Change</li>
                <li><i class="fa fa-check-circle"></i> Quota Change</li>
                <li><i class="fa fa-check-circle"></i> Question Language Change</li>
                <li><i class="fa fa-check-circle"></i> Dominant Hand Change</li>
                <li><i class="fa fa-check-circle"></i> Exam Center Choice Change</li>
              </ul>

              <div class="fee-notice">
                <i class="fa fa-info-circle"></i>
                <p>
                  You will be charged a total of
                  <strong class="fee-amount">300 TK</strong>
                  for <em>any or all</em> of the above changes.
                </p>
              </div>

              <div v-if="shouldShowApplyButton" class="action-section">
                <p class="confirmation-text">
                  Do you want to apply for profile correction?
                </p>
                <button
                  v-if="!isLoading"
                  @click="applyForCorrection"
                  class="btn btn-apply"
                  type="button"
                >
                  <i class="fa fa-paper-plane"></i> Apply for Correction
                </button>
                <button
                  v-else
                  class="btn btn-apply"
                  type="button"
                  disabled
                >
                  <i class="fa fa-spinner fa-spin"></i> Processing...
                </button>
              </div>

              <div v-else-if="hasCorrectionBill" class="bill-section">
                <div class="bill-details">
                  <h5 class="bill-title">
                    <i class="fa fa-file-text"></i> Correction Bill Details
                  </h5>

                  <div class="bill-info-grid">
                    <div class="bill-info-item">
                      <span class="label">Bill Number:</span>
                      <span class="value">{{ correctionForm.bill_number }}</span>
                    </div>
                    <div class="bill-info-item">
                      <span class="label">Amount:</span>
                      <span class="value fee">{{ correctionForm.amount }} TK</span>
                    </div>
                    <div class="bill-info-item">
                      <span class="label">Status:</span>
                      <span class="value" :class="statusClass">
                        {{ correctionForm.bill_status === 'confirmed' ? 'PAID' : correctionForm.bill_status.toUpperCase() }}
                      </span>
                    </div>
                  </div>

                  <div v-if="shouldShowPayment" class="payment-section">
                    <h6 class="payment-title">
                      <i class="fa fa-credit-card"></i> Choose Payment Method
                    </h6>

                    <div class="payment-buttons">
                      <button
                        v-if="!isPayButtonLoading"
                        @click="$emit('bkash-payment')"
                        class="btn btn-payment btn-bkash"
                        type="button"
                      >
                        <i class="fa fa-mobile"></i> Pay with bKash
                      </button>

                      <button
                        v-if="!isPayButtonLoading"
                        @click="$emit('rocket-payment')"
                        class="btn btn-payment btn-rocket"
                        type="button"
                      >
                        <i class="fa fa-rocket"></i> Pay with DBBL Rocket
                      </button>

                      <button
                        v-if="!isPayButtonLoading"
                        @click="$emit('visa-payment')"
                        class="btn btn-payment btn-visa"
                        type="button"
                      >
                        <i class="fa fa-cc-visa"></i> Pay with Visa
                      </button>

                      <button
                        v-if="!isPayButtonLoading"
                        @click="$emit('mastercard-payment')"
                        class="btn btn-payment btn-mastercard"
                        type="button"
                      >
                        <i class="fa fa-cc-mastercard"></i> Pay with MasterCard
                      </button>

                      <button
                        v-if="isPayButtonLoading"
                        class="btn btn-payment btn-loading"
                        type="button"
                        disabled
                      >
                        <i class="fa fa-spinner fa-spin"></i> Processing Payment...
                      </button>
                    </div>
                  </div>

                  <div v-else-if="isCorrectionBill && correctionForm.bill_status === 'confirmed'" class="success-message">
                    <i class="fa fa-check-circle"></i>
                    <p>Payment completed successfully! You can now edit your profile information.</p>
                  </div>
                </div>
              </div>

              <!-- Paid Correction Bills Table -->
              <div v-if="hasPaidBills" class="paid-bills-section">
                <h4 class="section-title">
                  <i class="fa fa-history"></i> Previous Correction Payments
                </h4>

                <div class="bills-table-container">
                  <table class="bills-table">
                    <thead>
                      <tr>
                        <th>Bill Number</th>
                        <th>Amount</th>
                        <th>Payment Method</th>
                        <th>Paid Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="bill in paidCorrectionBills" :key="bill.id">
                        <td>{{ bill.bill_number }}</td>
                        <td class="amount">{{ bill.fee }} TK</td>
                        <td>
                          <span class="payment-method" :class="'method-' + (bill.transaction_agent || 'unknown').toLowerCase()">
                            {{ bill.transaction_agent || 'N/A' }}
                          </span>
                        </td>
                        <td>{{ formatDate(bill.paid_at) }}</td>
                        <td>
                          <!-- <button
                            @click="showPaymentSlip(bill)"
                            class="btn btn-slip"
                            type="button"
                          >
                            <i class="fa fa-file-text"></i> Payment Slip
                          </button> -->

                          <button 
                                    class="btn  btn-slip radius-1 align-items-center" 
                                    @click="downloadPaySlip({
                                      unit:'CO',
                                      bill_status:bill.status,
                                      bill_number:bill.bill_number,
                                      agent:bill.transaction_agent,
                                      amount:bill.fee,
                                      paid_at:bill.paid_at
                                    })"
                                    :disabled="downloadingBills[bill.bill_number]"
                                    type="button"
                                  >
                                    
                                    <i 
                                      :class="downloadingBills[bill.bill_number] ? 'fa fa-spinner fa-spin' : 'fa fa-file-text'" 
                                      aria-hidden="true"
                                      style="font-size: 1.2em; margin-right: 8px;"
                                    ></i>

                                    
                                    <span style="font-size: 0.85rem;">
                                      {{ downloadingBills[bill.bill_number] ? paySlipProgresse : 'Payment Slip' }}
                                    </span>
                                  </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CorrectionPayslipGenerator from '@/utils/CorrectionPayslipGenerator'
export default {
  name: 'ProfileCorrection',
  props: {
    correctionForm: {
      type: Object,
      required: true
    },

    registrationForm: {
      type: Object,
      required: true
    },

    correctionApplied: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isPayButtonLoading: {
      type: Boolean,
      default: false
    },
    closePayment: {
      type: Boolean,
      default: false
    },
    paidCorrectionBills: {
      type: Array,
      default: () => []
    },
    closePaymentSlip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusClass() {
      const status = this.correctionForm.bill_status;
      if (status === 'confirmed') return 'status-paid';
      if (status === 'assigned') return 'status-due';
      return 'status-pending';
    },
    isCorrectionBill() {
      return this.correctionForm.bill_number && this.correctionForm.bill_number.toString().startsWith('9');
    },
    hasCorrectionBill() {
      // Check if correction bill exists (has bill_number and is assigned or confirmed)
      return this.correctionForm.bill_number &&
             (this.correctionForm.bill_status === 'assigned' || this.correctionForm.bill_status === 'confirmed');
    },
    shouldShowApplyButton() {
      // Show apply button when no correction bill exists yet
      return !this.hasCorrectionBill;
    },
    shouldShowPayment() {
      // Show payment options only when bill is assigned and starts with 9
      return this.isCorrectionBill &&
             this.correctionForm.bill_status === 'assigned' &&
             !this.closePayment;
    },
    hasPaidBills() {
      // Show paid bills table if there's at least one paid bill and payment slips are not closed
      return this.paidCorrectionBills.length > 0 && !this.closePaymentSlip;
    }
  },
  data(){

    return{
      paySlipProgresse: 'Preparing...',
      downloadingBills: {}
    }
  },

  methods: {
    
    async downloadPaySlip(paymentReceipe) {

      const billNumber = paymentReceipe.bill_number

      // Skip if already downloading
      if (this.downloadingBills[billNumber]) return
      // if (this.isDownloadingPaySlip) {
      //   return
      // }

      //this.isDownloadingPaySlip = true
      this.$set(this.downloadingBills, billNumber, true)
      this.paySlipProgresse = 'Preparing...'
      //console.log('paymentReceipe',paymentReceipe)
      //console.log('registrationForm',this.registrationForm)

      

      try {
        await CorrectionPayslipGenerator.generatePayslip(
          this.registrationForm,
          paymentReceipe,
          'PAID',
          (message, progress) => {
            this.paySlipProgresse = message
          },
          (error) => {
            console.error('Payment Receipet generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Payment Receipet. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Payment Receipet downloaded successfully!'
        })
      } catch (error) {
        console.error('Payment Receipet download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Payment Receipet. Please try again.'
        })
      } finally {
        //this.isDownloadingPaySlip = false
        this.$set(this.downloadingBills, billNumber, false)
        this.paySlipProgresse = 'Preparing...'
      }
    },
    
    applyForCorrection() {
      this.$emit('apply-correction');
    },
    showPaymentSlip(bill) {
      this.$emit('correction-payment-slip', bill.bill_number, bill.transaction_agent, bill.fee, bill.paid_at);
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    }
  }
}
</script>

<style scoped>
.profile-tab-content {
  padding: 0;
}

.cart-section {
  padding: 20px 0;
}

.correction-info-box {
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.info-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-title i {
  color: #6366f1;
  font-size: 24px;
}

.info-content {
  color: #333;
  line-height: 1.6;
}

.intro-text {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-bottom: 15px;
}

.correction-list {
  list-style: none;
  padding: 0;
  margin: 15px 0 20px 0;
}

.correction-list li {
  padding: 8px 0;
  color: #444;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.correction-list li i {
  color: #10b981;
  font-size: 16px;
}

.fee-notice {
  background: #f8f9fa;
  padding: 15px 18px;
  border-left: 4px solid #6366f1;
  border-radius: 8px;
  margin: 20px 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.fee-notice i {
  color: #6366f1;
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.fee-notice p {
  margin: 0;
  font-size: 15px;
  color: #333;
}

.fee-amount {
  color: #dc3545;
  font-size: 17px;
  font-weight: 700;
}

.action-section {
  margin-top: 30px;
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.confirmation-text {
  font-size: 17px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
}

.btn-apply {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.btn-apply:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
}

.btn-apply:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-apply i {
  margin-right: 8px;
}

.bill-section {
  margin-top: 30px;
}

.bill-details {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  border: 2px solid #e0e7ff;
}

.bill-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.bill-title i {
  color: #6366f1;
}

.bill-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.bill-info-item {
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.bill-info-item .label {
  font-weight: 600;
  color: #64748b;
  font-size: 14px;
}

.bill-info-item .value {
  font-weight: 700;
  color: #2c3e50;
  font-size: 15px;
}

.bill-info-item .value.fee {
  color: #dc3545;
  font-size: 18px;
}

.status-paid {
  color: #10b981 !important;
}

.status-due {
  color: #dc3545 !important;
}

.status-pending {
  color: #f59e0b !important;
}

.payment-section {
  margin-top: 25px;
  padding-top: 25px;
  border-top: 2px solid #e0e7ff;
}

.payment-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.payment-title i {
  color: #6366f1;
}

.payment-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.btn-payment {
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-bkash {
  background: linear-gradient(135deg, #e2136e 0%, #c7104d 100%);
  box-shadow: 0 4px 12px rgba(226, 19, 110, 0.3);
}

.btn-bkash:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(226, 19, 110, 0.4);
}

.btn-rocket {
  background: linear-gradient(135deg, #8e44ad 0%, #6c3483 100%);
  box-shadow: 0 4px 12px rgba(142, 68, 173, 0.3);
}

.btn-rocket:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(142, 68, 173, 0.4);
}

.btn-visa {
  background: linear-gradient(135deg, #1a1f71 0%, #0d1445 100%);
  box-shadow: 0 4px 12px rgba(26, 31, 113, 0.3);
}

.btn-visa:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(26, 31, 113, 0.4);
}

.btn-mastercard {
  background: linear-gradient(135deg, #eb001b 0%, #c40015 100%);
  box-shadow: 0 4px 12px rgba(235, 0, 27, 0.3);
}

.btn-mastercard:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(235, 0, 27, 0.4);
}

.btn-loading {
  background: #94a3b8;
  cursor: not-allowed;
}

.success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #6ee7b7;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  color: #065f46;
}

.success-message i {
  font-size: 48px;
  color: #10b981;
  display: block;
  margin-bottom: 15px;
}

.success-message p {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

/* Paid Bills Section */
.paid-bills-section {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #e0e7ff;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title i {
  color: #6366f1;
  font-size: 22px;
}

.bills-table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}

.bills-table {
  width: 100%;
  min-width: 700px;
  border-collapse: collapse;
}

.bills-table thead {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
}

.bills-table thead th {
  padding: 15px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bills-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s ease;
}

.bills-table tbody tr:hover {
  background-color: #f8fafc;
}

.bills-table tbody tr:last-child {
  border-bottom: none;
}

.bills-table tbody td {
  padding: 18px 20px;
  color: #475569;
  font-size: 15px;
}

.bills-table tbody td.amount {
  font-weight: 700;
  color: #dc3545;
  font-size: 16px;
}

.payment-method {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.method-bkash {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  color: #c7104d;
}

.method-rocket {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  color: #6c3483;
}

.method-visa {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
}

.method-mastercard {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #c40015;
}

.method-unknown {
  background: #f1f5f9;
  color: #64748b;
}

.btn-slip {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.btn-slip:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(34, 197, 94, 0.4);
}

.btn-slip i {
  margin-right: 6px;
}

@media (max-width: 768px) {
  .correction-info-box {
    padding: 20px;
  }

  .info-title {
    font-size: 18px;
  }

  .payment-buttons {
    grid-template-columns: 1fr;
  }

  .bill-info-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 18px;
  }

  .bills-table-container {
    overflow-x: auto;
  }

  .bills-table {
    min-width: 600px;
  }

  .bills-table thead th,
  .bills-table tbody td {
    padding: 12px 10px;
    font-size: 13px;
  }
}
</style>
